import { Intervention } from '@/app/components/action-plan/types';
import apiClient from '../client/api';

export type GetInterventions = {
  interventions: Intervention[];
};

type CompleteInterventionPayload = {
  id: string;
};

async function get(): Promise<GetInterventions> {
  const res = await apiClient.get('/action-plans/available-interventions');
  return res.data;
}

async function post(payload: CompleteInterventionPayload): Promise<void> {
  const res = await apiClient.post('/action-plans/current/completed-interventions', payload);
  return res.data;
}

export default { get, post };
